import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { compact, get } from 'lodash-es';

import PanelManager from './PanelManager';
import Subscription from './Subscription';

import { subscriptionList } from './utils';

import './SubscriptionsBlock.scss';

class Subscriptions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: true,
    };
  }

  static componentDidMount() {
    const { expanded } = this.props;
    this.setState({
      expanded,
    });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { expanded } = nextProps;
    let newState = null;
    if (expanded !== prevState.expanded) {
      newState = { ...newState, expanded };
    }
    return newState;
  }

  getTitle = strings => get(strings, 'title');

  render() {
    const { expanded } = this.state;
    const {
      config,
      formApi,
      formState,
      setExpanded,
      classes,
      onSubscribe,
      onCancel,
      readOnly,
      strings,
      data,
      actionsState,
      validate,
      defaultValues,
    } = this.props;
    const values = get(formState, 'values');
    const subscriptionElements = subscriptionList({ values });

    const toggleExpanded = () => {
      setExpanded('subscriptions', !expanded);
    };

    // eslint-disable-next-line no-unused-vars
    const handleSubscribe = value => {
      this.setState({
        // selectedValue: value,
      });
      let subvalues = get(formApi.getState(), 'values');
      if (subvalues.subscriptions) {
        subvalues = { ...subvalues, subscriptions: compact(get(subvalues, 'subscriptions', [])) };
      }
      onSubscribe(subvalues);
    };

    // eslint-disable-next-line no-unused-vars
    const handleCancel = value => {
      this.setState({
        // selectedValue: value,
      });
      let subvalues = get(formApi.getState(), 'values');
      if (subvalues.subscriptions) {
        subvalues = { ...subvalues, subscriptions: compact(get(subvalues, 'subscriptions', [])) };
      }
      onCancel(subvalues);
    };

    return (
      <PanelManager
        expanded={expanded}
        toggleExpanded={toggleExpanded}
        strings={strings}
        handleSubscribe={handleSubscribe}
        handleCancel={handleCancel}
        classes={classes}
        actionsState={actionsState}
        readOnly={readOnly}
        disabled={get(actionsState, 'btn.subscribe.disable', readOnly)}
        validate={validate}
      >
        <div className="subscriptions block">
          {/*  One Subscription per covered element */}
          {subscriptionElements.map((subscriptionItem, index) => (
            <Subscription
              // eslint-disable-next-line react/no-array-index-key
              key={`subscription-${index}`}
              index={index}
              config={config}
              subscriptionItem={subscriptionItem}
              strings={strings}
              readOnly={readOnly}
              data={data}
              formApi={formApi}
              formState={formState}
              disabled={get(actionsState, 'btn.subscribe.disable', readOnly)}
              defaultValues={defaultValues}
            />
          ))}
        </div>
      </PanelManager>
    );
  }
}

Subscriptions.propTypes = {
  data: PropTypes.any.isRequired, // eslint-disable-line
  strings: PropTypes.objectOf(PropTypes.string),
  formApi: PropTypes.any.isRequired, // eslint-disable-line
  formState: PropTypes.any.isRequired, // eslint-disable-line
  expanded: PropTypes.bool.isRequired,
  setExpanded: PropTypes.func.isRequired,
  classes: PropTypes.any.isRequired, // eslint-disable-line
  onSubscribe: PropTypes.func.isRequired, // eslint-disable-line
  onCancel: PropTypes.func.isRequired, // eslint-disable-line
  readOnly: PropTypes.bool.isRequired,
  config: PropTypes.any.isRequired, // eslint-disable-line
  actionsState: PropTypes.object, // eslint-disable-line
  validate: PropTypes.object.isRequired, // eslint-disable-line
  defaultValues: PropTypes.object, // eslint-disable-line
};
Subscriptions.defaultProps = {
  strings: {},
  defaultValues: undefined,
};

const styles = theme => ({
  root: {},
  formControl: {},
  selectEmpty: {},
  button: {},
  input: {},
  details: {
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      margin: 0,
    },
  },
});

export default withStyles(styles)(Subscriptions);
